import {host} from "~/utils/constants";

export class BlogArticle{
    id = 0
    slug = ""
    Title = ""
    Description = ""
    jsonContent = {}
    Featured= false
    image = {id:0,url:""}
    publishedAt:Date|null= new Date()

    category= {
        id: 0,
        name: ""
    }

    // Rehydrate a plain object into a Reference instance
    fromJSON(obj: Partial<BlogArticle>): BlogArticle {
        return Object.assign(new BlogArticle(), obj)
    }
    parseJson(ret: { id: number; attributes: { [key: string]: any } }) {
        this.id = ret.id;
        this.Title = ret.attributes.Title
        this.slug = ret.attributes.slug
        this.Description = ret.attributes.Description
        this.jsonContent = ret.attributes.jsonContent?ret.attributes.jsonContent:{};
        this.Featured = ret.attributes.Featured
        this.publishedAt = ret.attributes.publishedAt ? new Date(ret.attributes.publishedAt) : null
        this.category = ret.attributes.blog_category && ret.attributes.blog_category.data ? {
            id: ret.attributes.blog_category.data.id,
            name: ret.attributes.blog_category.data.attributes.Name
        } : {id:0,name:""}
        this.image = ret.attributes.Image.data ? {
            url:host+ret.attributes.Image.data.attributes.url,
            id:ret.attributes.Image.data.id
        } : {id:-1, url:""};
    }
    toJSON () {
        return {...this}
    }


    toApiJSON(){
        return {
            ...this,
            image: null,
            blog_category: this.category.id > 0 ? this.category.id : null,
            Image: this.image.id > 0 ? this.image.id : null
        } // here I make a POJO's copy of the class instance
    }
}